// pages/CartPage.js
import React, { useEffect, useState } from 'react';
import { useCart } from '../hooks/useCart';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient/supabaseClient';

const CartPage = () => {
  const { cart, removeFromCart, cartTotal } = useCart();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loginWarning, setLoginWarning] = useState(false);

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => {
      setUser(user);
    });
  }, []);

  const handleCheckout = () => {
    if (!user) {
      setLoginWarning(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigate('/satinAl', { state: { step: 2 } });
  };

  return (
    <div style={{ padding: '40px', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Sepetim</h1>

      {/* Giriş yapılmamış uyarısı */}
      {loginWarning && (
        <div style={{
          background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '10px',
          padding: '14px 18px', marginBottom: '20px', color: '#856404', fontWeight: 600
        }}>
          Ödemeye geçmek için lütfen{' '}
          <Link to="/Uyegirisi" style={{ color: '#001f3f', fontWeight: 700 }}>giriş yapın</Link>
          {' '}veya{' '}
          <Link to="/Uyeol" style={{ color: '#001f3f', fontWeight: 700 }}>üye olun</Link>.
        </div>
      )}

      {cart.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p>Sepetinizde ürün bulunmuyor.</p>
          <Link to="/SatinAl">Paketleri İncele</Link>
        </div>
      ) : (
        <>
          <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '10px' }}>
            {cart.map((item) => (
              <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ddd', padding: '15px 0' }}>
                <div>
                  <strong>{item.full_name || item.name}</strong>
                  <div style={{ fontSize: '0.9rem', color: '#666' }}>{item.description || item.desc}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <span style={{ fontWeight: 'bold' }}>{item.price_display || item.price + " ₺"}</span>
                  <button
                    onClick={() => removeFromCart(item.id)}
                    style={{ background: '#dc3545', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '5px', cursor: 'pointer' }}
                  >
                    Sil
                  </button>
                </div>
              </div>
            ))}

            <div style={{ marginTop: '20px', textAlign: 'right', fontSize: '1.3rem' }}>
              Toplam: <strong style={{ color: '#28a745' }}>{cartTotal.toFixed(2)} ₺</strong>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px' }}>
            <Link to="/SatinAl" style={{ textDecoration: 'none', color: '#555', alignSelf: 'center' }}>
              ← Alışverişe Dön
            </Link>
            <button
              onClick={handleCheckout}
              style={{
                padding: '15px 40px', fontSize: '1.1rem', fontWeight: 'bold',
                background: '#28a745', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer'
              }}
            >
              Ödemeyi Tamamla
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;
